import { List, Map } from "immutable";

export const mergeUnique = (arr1: any[], arr2: any[], key: string): any => {
  return List(arr1)
    .concat(List(arr2))
    .reduce(
      (acc, item) => acc.set(item[key].toString(), item),
      Map<string, any>(),
    )
    .valueSeq();
};
